"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    propNameDecorator: ()=>propNameDecorator
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_extractArgTypeCombinations_cjs_namespaceObject = require("./extractArgTypeCombinations.cjs");
const external_SnapshotPanel_cjs_namespaceObject = require("./SnapshotPanel.cjs");
function propNameDecorator(Story, context) {
    const propName = context.parameters?.propName;
    const additionalPropNames = context.parameters?.additionalPropNames || [];
    const additionalProps = context.parameters?.additionalProps || [];
    const component = context.parameters?.component;
    if (!propName || !component) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Story, {});
    const props = (0, external_extractArgTypeCombinations_cjs_namespaceObject.extractArgTypeCombinations)(context.args, context.argTypes, false);
    const componentProps = props.find((prop)=>prop.propName === propName)?.props;
    const additionalComponentProps = additionalPropNames.map((propName)=>props.find((prop)=>prop.propName === propName)?.props).flat();
    if (componentProps) {
        let effectedRenderedProps = componentProps;
        if (additionalComponentProps.length > 0) effectedRenderedProps = additionalComponentProps.reduce((acc, additionalComponentProp)=>{
            componentProps.forEach((componentProp)=>{
                acc.push({
                    ...additionalComponentProp,
                    ...componentProp
                });
            });
            return acc;
        }, []);
        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_SnapshotPanel_cjs_namespaceObject.SnapshotPanel, {
                    component: component,
                    propName: propName,
                    props: effectedRenderedProps
                }),
                additionalProps.map((prop)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_SnapshotPanel_cjs_namespaceObject.SnapshotPanel, {
                        component: component,
                        propName: propName,
                        props: effectedRenderedProps,
                        additionalProps: prop
                    }, prop.propName))
            ]
        });
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Story, {});
}
exports.propNameDecorator = __webpack_exports__.propNameDecorator;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "propNameDecorator"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
